// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d158f6f0","885":"0f50dc39"}[chunkId] + ".chunk.js";
};